import React from 'react';
import {injectIntl} from "react-intl";

const NoAuthBlockDescription = ({intl}) => intl.formatMessage({id: 'Job.NoFavouriteJobs.Message'});

export default injectIntl(NoAuthBlockDescription);
